export const MAX_INTERVAL_TIME_YEARS = 5;
export const MIN_DATE_SHOWN_EPOCH = 946677600;

export const SPOTLIGHT_NAMES = {
	actions: 'eoc-heartbeats_actions',
};
